export default __webpack_public_path__ + "static/media/fileFormat.7c9e734a.svg";